/**
 * Open/closed state of the Properties, Attributes and Charts panels, kept next to the dock
 * layout (`ultimate-gis:layout:v1`) so a reload restores them. Guarded: storage can be
 * unavailable or hold junk, in which case every panel starts closed.
 */
export const PANEL_OPEN_KEY = 'ultimate-gis:panels-open:v1';
export const PERSISTED_PANELS = ['showStyleEditor', 'showAttributeTable', 'showChartPanel'];

export function loadPanelOpen(storage) {
  try {
    const s = storage || window.localStorage;
    const raw = JSON.parse(s.getItem(PANEL_OPEN_KEY) || 'null');
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
    return Object.fromEntries(PERSISTED_PANELS.map((k) => [k, raw[k] === true]));
  } catch {
    return {};
  }
}

export function savePanelOpen(state, storage) {
  try {
    const s = storage || window.localStorage;
    s.setItem(PANEL_OPEN_KEY, JSON.stringify(Object.fromEntries(PERSISTED_PANELS.map((k) => [k, !!state[k]]))));
  } catch {
    /* storage unavailable: state just does not persist */
  }
}
